<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">Region Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>Region Name</td>
                  <td>
                    {{ regionModel.name ? regionModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Region Id</td>
                  <td>
                    {{ regionModel.id ? regionModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New Region</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Region } from "@/models/Region";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      regionModel: new Region(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "Regions",
          disabled: false,
          href: "/admin/regions",
        },
        {
          text: "Region Details",
          disabled: false,
          href: `/admin/region/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    region: {
      query: gql`
        query Region($id: ID!) {
          region(id: $id) {
            id
            name
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.regionModel.id = this.region.id;
        this.regionModel.name = this.region.name;
        this.regionModel.createdBy = this.region.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
